import React, { useEffect, useState } from 'react';

import { SearchableDropdown } from '@scholastic/volume-react';

import StepDescription from '../StepDescription/StepDescription';
import { TypeOfReport } from '../ReportSelector/ReportType.data';
import { SearchableDropdownValue } from '../Home.dataparser';

import './DateSelector.scss';

export interface DateSelectorProps {
  availableDates: Array<SearchableDropdownValue>;
  reportType: TypeOfReport;
  onDateSelect: (value: string | undefined) => void;
  OnStartDateSelect?: (value: string | undefined) => void;
}

const DateSelector = ({
  availableDates,
  reportType,
  onDateSelect,
  OnStartDateSelect,
}: DateSelectorProps) => {
  const [selectedEndDate, setSelectedEndDate] = useState<SearchableDropdownValue>();

  const isSummaryReport = reportType === 'OSR' || reportType === 'UGR' || reportType === 'SRISR';

  useEffect(() => {
    onDateSelect(selectedEndDate?.value);
  }, [selectedEndDate, onDateSelect]);

  return (
    <div className="stats-date-selector">
      <div className="stats-date-selector__section-element">
        {!isSummaryReport && (
          <StepDescription order="3" description="Show stats for the previous 15 months starting" />
        )}
        {isSummaryReport && <StepDescription order="3" description="Select your Date(range)" />}
      </div>

      {!isSummaryReport && (
        <div className="stats-date-selector__section-element" id="single-date">
          <SearchableDropdown
            items={availableDates}
            placeholder="Search for the Date"
            onItemSelect={setSelectedEndDate}
          />
        </div>
      )}

      {isSummaryReport && (
        <div className="stats-date-selector__section-element">
          <div className="stats-date-selector__row" id="from-date">
            <div className="stats-date-selector__col col--small-3">From:</div>
            <div className="stats-date-selector__col col--small-9">
              <SearchableDropdown
                items={availableDates}
                placeholder="Search for the Date"
                onItemSelect={(startDate) => {
                  OnStartDateSelect && OnStartDateSelect(startDate.value);
                }}
              />
            </div>
          </div>
          <div className="stats-date-selector__row" id="to-date">
            <div className="stats-date-selector__col col--small-3">To:</div>
            <div className="stats-date-selector__col col--small-9">
              <SearchableDropdown
                items={availableDates}
                placeholder="Search for the Date"
                onItemSelect={setSelectedEndDate}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DateSelector;
